import React from 'react';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';

const PolicyPage = () => (
  <div className="policy-page page-with-navbar-footer">
    <Navbar />
    <main className="policy-content" style={{ minHeight: '60vh', padding: '40px 0', background: '#181818', color: '#fff' }}>
      <div className="container" style={{ maxWidth: 800, margin: '40px auto', padding: 24 }}>
        <h1 style={{ fontFamily: 'Orbitron, monospace', color: '#FFD700', fontWeight: 800 }}>Privacy Policy</h1>
        <p style={{ marginTop: 24 }}>
          <b>Effective Date: 2024-05-01</b>
        </p>
        <p>
          <b>Welcome to Cheda Gaming!</b> Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform, in accordance with Kenyan law.
        </p>
        <h2>1. Information We Collect</h2>
        <ul>
          <li><b>Personal Information:</b> Name, email address, phone number, date of birth, and payment details when you register or participate in tournaments.</li>
          <li><b>Usage Data:</b> Information about how you use our website, including IP address, browser type, device information, and pages visited.</li>
          <li><b>Cookies:</b> We use cookies and similar technologies to enhance your experience and analyze usage.</li>
        </ul>
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To create and manage your account</li>
          <li>To facilitate tournament participation and prize distribution</li>
          <li>To communicate with you about updates, promotions, and support</li>
          <li>To improve our services and user experience</li>
          <li>To comply with legal obligations under Kenyan law</li>
        </ul>
        <h2>3. Sharing Your Information</h2>
        <ul>
          <li>We do not sell your personal information.</li>
          <li>We may share your data with trusted third-party service providers (e.g., payment processors) as necessary to operate our platform.</li>
          <li>We may disclose information if required by law or to protect our rights and users.</li>
        </ul>
        <h2>4. Your Rights</h2>
        <ul>
          <li>You have the right to access, correct, or delete your personal information.</li>
          <li>You may opt out of marketing communications at any time.</li>
          <li>To exercise your rights, contact us at <a href="mailto:support@chedagaming.com" style={{ color: '#FFD700' }}>support@chedagaming.com</a>.</li>
        </ul>
        <h2>5. Data Security</h2>
        <p>We implement reasonable security measures to protect your data. However, no method of transmission over the internet is 100% secure.</p>
        <h2>6. Children's Privacy</h2>
        <p>Cheda Gaming is not intended for children under 18. We do not knowingly collect data from minors. If you believe a child has provided us with personal information, please contact us for removal.</p>
        <h2>7. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page.</p>
        <h2>8. Contact Us</h2>
        <p>If you have questions or concerns about this Privacy Policy, contact us at <a href="mailto:support@chedagaming.com" style={{ color: '#FFD700' }}>support@chedagaming.com</a>.</p>
      </div>
    </main>
    <Footer />
  </div>
);

export default PolicyPage; 